import React from "react"
import SbEditable from "storyblok-react"
import { blokType } from "../../types"

import { TestimonialsCmp, TestimonialsProps } from "./Testimonials"

interface TestimonialsWBlokProps {
  blok: TestimonialsProps & blokType
}

export const Testimonials: React.FC<TestimonialsWBlokProps> = ({ blok }) => {
  return (
    <SbEditable content={blok}>
      <TestimonialsCmp
        name={blok.name}
        nationality={blok.nationality}
        graduation_year={blok.graduation_year}
        program={blok.program}
        quote={blok.quote}
        image={blok.image}
        font={blok.font}
      ></TestimonialsCmp>
    </SbEditable>
  )
}

export * from "./shared-components"
